<template>
  <div class='modal'>
    <Button @click="modalBtn(msg,handleSelectData,parentId)">
      <Icon :type="icon" />{{msg}}
    </Button>
    <Modal
      v-model="modal1"
      footer-hide
      :draggable="true"
    >
      <p slot="header">
        <span>{{msg}}班级</span>
      </p>
      <Form
        v-if="msg!='删除'"
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem
          style="margin-bottom:22px"
          label="班级名称"
          prop="orgname"
        >
          <Input
            v-model="formValidate.orgname"
            placeholder="请输入名称"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="班级编号"
        >
          <Input
            v-model="formValidate.orgcode"
            placeholder="请输入编号"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="班级简称"
        >
          <Input
            v-model="formValidate.orgshortname"
            placeholder="请输入班级简称"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="负责人"
        >
          <Input
            v-model="formValidate.manager"
            placeholder="请输入负责人"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="联系电话"
        >
          <Input
            type="text"
            v-model="formValidate.phone"
            placeholder="请输入联系电话"
          ></Input>
        </FormItem>

        <FormItem style="margin-left:290px">
          <Button
            type="primary"
            @click="ok('formValidate')"
          >提交</Button>
        </FormItem>
      </Form>

      <p
        v-else
        style="text-align:center;font-size:20px"
      >
        <Icon
          style="font-size:30px;color:red"
          type="ios-alert-outline"
        />是否确认删除所选项
        <Button
          type="primary"
          style="margin-left:380px;margin-top:20px;width:80px"
          @click="del"
        >
          确定
        </Button>
      </p>

    </Modal>

  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      modal1: false,
      title: '',
      formValidate: {
        orgname: '',
        orgcode: '',
        parentid: '',
        orgshortname: '',
        manager: '',
        phone: ''
      },
      ruleValidate: {
        orgname: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
      },


    }
  },
  props: {
    msg: String,
    icon: String,
    handleSelectData: Object,
    parentId: Array,

  },
  created () {

  },
  methods: {
    async modalBtn (msg, handleSelectData, parentId) {
      console.log(this.$store.state.GetspecialtynList);
      if (msg == '新增' && JSON.stringify(this.$store.state.GetspecialtynList) == '{}') {
        return this.$Message.info('请选择专业！')
      }
      if (msg == '删除' || msg == '编辑') {
        if (handleSelectData == null) {
          return this.$Message.info('请选择操作项！')
        }
      }
      if (msg == '编辑') {
        this.formValidate = handleSelectData
      }
      this.modal1 = true
    },
    async getClassList () {
      const req = await Api.organization.GetClassList(this.$store.state.GetspecialtynList.orgid)
      this.$emit('tableData', req.rows)
    },
    ok (value) {
      this.$refs[value].validate(async (valid) => {
        if (valid) {
          this.formValidate.specialtyid = this.$store.state.GetspecialtynList.orgid
          this.formValidate.schoolid = '0d4bc22d669f48a6aa7d18df4872cea9'
          const res = await Api.organization.SaveClass(this.formValidate)
          if (res.success != true) return this.Message.info(res.msg)
          this.$Message.info(res.msg);
          this.getClassList()
          this.formValidate = {}
          this.modal1 = false
        } else {
          this.$Message.error('请确认表格信息完整!');
        }
      })
    },
    async del () {
      const res = await Api.organization.DelOrganization([this.handleSelectData.orgid])
      if (res.success != true) return this.Message.info(res.msg)
      this.$Message.success(res.msg)
      this.getClassList()
      this.modal1 = false
    },

    //复选框事件
    boxChange (e) {
      if (e) {
        console.log(e);
        this.formValidate.isenable = 1
      } else {
        this.formValidate.isenable = 0
      }
    },

  }
}
</script>
<style lang='less' scoped>
.modal {
  display: inline-block;
  button {
    padding: 5px 10px;
    margin-left: 10px;
    text-align: center;
  }
}
</style>